import React from 'react';
import {Elements} from 'react-stripe-elements';
import {Mutation} from 'react-apollo';
import gql from 'graphql-tag';
import {PulseLoader} from 'react-spinners';
import {LoadingContainer} from '../../../common/components/StyledComp';
import StripeAddPaymentMethod, {parentPropTypes} from './StripeAddPaymentMethod';

const GRAPHQL_MUTATION_UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod($userId: ID!, $paymentMethodId: ID!) {
    updatePaymentMethod(userId: $userId, paymentMethodId: $paymentMethodId) {
      id
      hasValidPaymentMethod
      paymentMethod {
        id
        card {
          id
          brand
          expMonth
          expYear
          last4
        }
      }
    }
  }
`;

const AddPaymentMethod = ({...stripeMutationProps}) => (
  <Mutation mutation={GRAPHQL_MUTATION_UPDATE_PAYMENT_METHOD}>
    {(mutation, {loading}) => {
      if (loading) {
        return (
          <LoadingContainer>
            <PulseLoader/>
          </LoadingContainer>
        );
      }
      return (
        <Elements>
          <StripeAddPaymentMethod mutation={mutation} {...stripeMutationProps}/>
        </Elements>
      );
    }}
  </Mutation>
);

AddPaymentMethod.propTypes = {
  ...parentPropTypes,
};

export default AddPaymentMethod;
